/**
 * Permission denied page shown when a user lacks access to a requested resource.
 *
 * @module pages/PermissionDenied
 * @author Covintus
 * @author Snowfly
 * @version 1.0.0
 */
import React from 'react';
import { Button, IconButton } from '@material-ui/core';
import iLearnLogo from '../assets/images/icons/iLearnLogo.png';

/**
 * Navigates the user back to the dashboard and sets a localStorage flag.
 *
 * @returns {void}
 */
const handleBack = () => {
    window.location.href = '/dashboard';
    localStorage.setItem('backToDashboard', true);
};

/**
 * Displays a permission-denied message with a back-to-dashboard button.
 *
 * @component
 * @returns {JSX.Element} The permission denied page layout.
 */
const PermissionDenied = () => (
    <div>
        <IconButton onClick={handleBack}>
            <img alt="logo" src={iLearnLogo} width="85vw" />
        </IconButton>
        <div style={{ textAlign: 'center', margin: '12rem 0rem' }}>
            <h1>
                You don&apos;t seem to have the required permissions to access this page.
                <br />
                {' '}
                Please contact your system administrator.
            </h1>
            <Button color="primary" variant="contained" onClick={handleBack}>Back to Dashboard</Button>
        </div>
    </div>
);

export default PermissionDenied;
